<template>
  <div class="relative p-1 rounded-md bg-secondary-red-10">
    <svg xmlns="http://www.w3.org/2000/svg" :width="width - 8" :height="height - 8" viewBox="0 0 20 20" fill="none"
    @mouseenter="iconHovered" @mouseleave="iconUnhovered">
      <path d="M12.25 10.7502C12.6642 10.7502 13 10.4144 13 10.0002C13.0001 9.586 12.6643 9.25015 12.2501 9.25015L12.25 10.7502ZM7.75004 9.25C7.33583 9.25 7.00003 9.58578 7.00002 9.99993C6.99999 10.4142 7.33577 10.75 7.74999 10.75L7.75004 9.25ZM12.2501 9.25015L7.75004 9.25L7.74999 10.75L12.25 10.7502L12.2501 9.25015ZM15.25 6.4V13.6H16.75V6.4H15.25ZM13.6 15.25H6.4V16.75H13.6V15.25ZM4.75 13.6V6.4H3.25V13.6H4.75ZM6.4 4.75H13.6V3.25H6.4V4.75ZM6.4 15.25C5.96759 15.25 5.68838 15.2494 5.47588 15.2321C5.27213 15.2154 5.19659 15.1872 5.15951 15.1683L4.47852 16.5048C4.76231 16.6494 5.05722 16.7028 5.35373 16.7271C5.64148 16.7506 5.99234 16.75 6.4 16.75V15.25ZM3.25 13.6C3.25 14.0076 3.24942 14.3586 3.27293 14.6463C3.29715 14.9428 3.35064 15.2377 3.49524 15.5215L4.83174 14.8405C4.81285 14.8034 4.78459 14.7279 4.76795 14.5242C4.75059 14.3116 4.75 14.0324 4.75 13.6H3.25ZM5.15951 15.1683C5.01839 15.0963 4.90365 14.9816 4.83174 14.8405L3.49524 15.5215C3.71095 15.9449 4.05516 16.2891 4.47852 16.5048L5.15951 15.1683ZM15.25 13.6C15.25 14.0324 15.2494 14.3116 15.2321 14.5242C15.2154 14.7279 15.1872 14.8034 15.1683 14.8405L16.5048 15.5215C16.6494 15.2377 16.7028 14.9428 16.7271 14.6463C16.7506 14.3586 16.75 14.0076 16.75 13.6H15.25ZM13.6 16.75C14.0077 16.75 14.3586 16.7506 14.6463 16.7271C14.9428 16.7028 15.2377 16.6494 15.5215 16.5048L14.8405 15.1683C14.8034 15.1872 14.7279 15.2154 14.5242 15.2321C14.3116 15.2494 14.0325 15.25 13.6 15.25V16.75ZM15.1683 14.8405C15.0963 14.9816 14.9817 15.0963 14.8405 15.1683L15.5215 16.5048C15.9449 16.2891 16.2891 15.9449 16.5048 15.5215L15.1683 14.8405ZM16.75 6.4C16.75 5.99234 16.7506 5.64148 16.7271 5.35373C16.7028 5.05722 16.6494 4.76231 16.5048 4.47852L15.1683 5.15951C15.1872 5.19659 15.2154 5.27213 15.2321 5.47588C15.2494 5.68838 15.25 5.96759 15.25 6.4H16.75ZM13.6 4.75C14.0325 4.75 14.3116 4.75059 14.5242 4.76795C14.7279 4.78459 14.8034 4.81285 14.8405 4.83174L15.5215 3.49524C15.2377 3.35064 14.9428 3.29715 14.6463 3.27293C14.3586 3.24942 14.0077 3.25 13.6 3.25V4.75ZM16.5048 4.47852C16.2891 4.05516 15.9449 3.71095 15.5215 3.49524L14.8405 4.83174C14.9817 4.90365 15.0963 5.01839 15.1683 5.15951L16.5048 4.47852ZM4.75 6.4C4.75 5.96759 4.75059 5.68838 4.76795 5.47588C4.78459 5.27213 4.81285 5.19659 4.83174 5.15951L3.49524 4.47852C3.35064 4.76231 3.29715 5.05722 3.27293 5.35373C3.24942 5.64148 3.25 5.99234 3.25 6.4H4.75ZM6.4 3.25C5.99234 3.25 5.64148 3.24942 5.35373 3.27293C5.05722 3.29715 4.76231 3.35064 4.47852 3.49524L5.15951 4.83174C5.19659 4.81285 5.27213 4.78459 5.47588 4.76795C5.68838 4.75059 5.96759 4.75 6.4 4.75V3.25ZM4.83174 5.15951C4.90365 5.01839 5.01839 4.90365 5.15951 4.83174L4.47852 3.49524C4.05516 3.71095 3.71095 4.05516 3.49524 4.47852L4.83174 5.15951Z" 
      fill="#710E21"/>
    </svg>
    <transition>
      <div v-if="showTooltip" class="tooltip px-2 py-1 rounded-md shadow-lg w-max">
        <BaseText type="label" size="xs" class="text-white">
          Excluded
        </BaseText>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ExcludedFiltersIcon',
  props: {
    width: {
      type: Number,
      default: 28
    },
    height: {
      type: Number,
      default: 28
    }
  },
  data () {
    return {
      showTooltip: false,
      tooltipTimeout: null
    }
  },
  methods: {
    iconHovered () {
      clearTimeout(this.tooltipTimeout)
      this.tooltipTimeout = setTimeout(() => {
        this.showTooltip = true
      }, 1000)
    },
    iconUnhovered () {
      clearTimeout(this.tooltipTimeout)
      this.showTooltip = false
    }
  }
}
</script>

<style scoped>
.tooltip {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #100f1b;
}

.v-enter-active, .v-leave-active {
  transition: opacity 150ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>